function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2fbff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.593,
  stopColor: "#faf7f7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3eae6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.147,
  y1: 0.5,
  x2: 2.585,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3b2a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a5119f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -0.137,
  y1: 0.5,
  x2: 0.628,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7a719b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3d3169"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 0.028,
  y1: 0.181,
  x2: 0.721,
  y2: 1.194,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a5119f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3b2a82"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -0.073,
  y1: 0.5,
  x2: 0.984,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3b2a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.593,
  stopColor: "#6b53d0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5f3fe5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: 0.186,
  y1: 0.5,
  x2: 1.074,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3b2a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.704,
  stopColor: "#3b2a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3b2a82"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "search",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4685",
  "data-name": "Group 4685",
  transform: "translate(0 6.885)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  cx: 18.401,
  cy: 18.401,
  rx: 18.401,
  ry: 18.401,
  transform: "translate(12.22 0)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3496",
  "data-name": "Path 3496",
  d: "M74.54,110.124H4.977A4.819,4.819,0,0,1,0,105.481V84.975a4.819,4.819,0,0,1,4.977-4.643H74.54a4.819,4.819,0,0,1,4.977,4.643v20.506A4.819,4.819,0,0,1,74.54,110.124Z",
  transform: "translate(0 -80.332)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3497",
  "data-name": "Path 3497",
  d: "M196.6,80.332a18.4,18.4,0,0,1,14.452,29.792h8.128a25.3,25.3,0,0,0-5.238-29.792Z",
  transform: "translate(-162.667 -80.332)",
  fill: "#e4e2eb"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3498",
  "data-name": "Path 3498",
  d: "M171.963,85.727a18.371,18.371,0,0,0-15.545-5.214,18.4,18.4,0,0,1,0,36.452,18.4,18.4,0,0,0,15.545-31.237Z",
  transform: "translate(-128.331 -80.337)",
  fill: "#e4e2eb"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4684",
  "data-name": "Group 4684",
  transform: "translate(12.608 5.251)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3499",
  "data-name": "Path 3499",
  d: "M73.7,118.04c0-.882-1.452-1.608-2.619-1.608-.622,0-1.141.207-1.3.752l-3.941,13.3-2.048-8.764c-.156-.7-1.063-1.063-1.945-1.063s-1.789.363-1.945,1.063l-2.048,8.764-3.941-13.3c-.155-.545-.674-.752-1.3-.752-1.167,0-2.619.726-2.619,1.608a1.152,1.152,0,0,0,.052.337l5.16,15.816c.285.907,1.478,1.348,2.671,1.348,1.167,0,2.411-.441,2.619-1.348l1.348-6.145,1.348,6.145c.207.907,1.452,1.348,2.619,1.348,1.193,0,2.359-.441,2.671-1.348l5.16-15.816A1.153,1.153,0,0,0,73.7,118.04Z",
  transform: "translate(-49.999 -116.432)",
  fill: "#ff3067",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3500",
  "data-name": "Path 3500",
  d: "M226.044,160.817a1.059,1.059,0,0,0-1.089.622l-2.308,6.586-1.659-5.575c-.207-.7-.752-.778-1.322-.778-.6,0-1.115.078-1.322.778l-1.659,5.575-2.308-6.586a1.07,1.07,0,0,0-1.115-.622c-1.037,0-2.645.674-2.645,1.608a1.337,1.337,0,0,0,.13.545l3.993,9.982c.207.519.882.7,1.53.7.778,0,1.53-.259,1.685-.7l1.711-4.512,1.711,4.512c.156.441.882.7,1.659.7.674,0,1.348-.181,1.556-.7l3.993-9.982a1.123,1.123,0,0,0,.1-.493C228.689,161.491,227.029,160.817,226.044,160.817Z",
  transform: "translate(-187.254 -154.361)",
  fill: "#ff3067",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3501",
  "data-name": "Path 3501",
  d: "M351.182,160.817a1.059,1.059,0,0,0-1.089.622l-2.308,6.586-1.659-5.575c-.207-.7-.752-.778-1.322-.778-.6,0-1.115.078-1.322.778l-1.659,5.575-2.308-6.586a1.07,1.07,0,0,0-1.115-.622c-1.037,0-2.645.674-2.645,1.608a1.334,1.334,0,0,0,.13.545l3.993,9.982c.207.519.882.7,1.53.7.778,0,1.53-.259,1.685-.7l1.711-4.512,1.711,4.512c.156.441.882.7,1.659.7.674,0,1.348-.181,1.556-.7l3.993-9.982a1.124,1.124,0,0,0,.1-.493C353.827,161.491,352.168,160.817,351.182,160.817Z",
  transform: "translate(-294.19 -154.361)",
  fill: "#ff3067"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3502",
  "data-name": "Path 3502",
  d: "M338.4,160.817c-1.037,0-2.645.674-2.645,1.608a1.334,1.334,0,0,0,.13.545l3.993,9.982a.862.862,0,0,0,.255.344,25.387,25.387,0,0,0,.5-8.653l-1.122-3.2A1.07,1.07,0,0,0,338.4,160.817Z",
  transform: "translate(-294.191 -154.361)",
  opacity: 0.3,
  fill: "url(#linear-gradient-2)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3503",
  "data-name": "Path 3503",
  d: "M443.019,80.332h-5.967a4.643,4.643,0,0,1,4.643,4.643v20.506a4.643,4.643,0,0,1-4.643,4.643h5.967a4.643,4.643,0,0,0,4.643-4.643V84.975A4.643,4.643,0,0,0,443.019,80.332Z",
  transform: "translate(-368.145 -80.332)",
  fill: "#e4e2eb"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_4687",
  "data-name": "Group 4687",
  transform: "translate(5.335 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3504",
  "data-name": "Path 3504",
  d: "M267.63,304.893l-7.128-7.128a2.937,2.937,0,0,1,0-4.154l.11-.109a2.937,2.937,0,0,1,4.154,0l7.129,7.128a2.937,2.937,0,0,1,0,4.154l-.11.11A2.937,2.937,0,0,1,267.63,304.893Z",
  transform: "translate(-221.875 -254.874)",
  fill: "url(#linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3505",
  "data-name": "Path 3505",
  d: "M25.286,33A25.286,25.286,0,1,0,50.572,58.286,25.286,25.286,0,0,0,25.286,33Zm0,43.687a18.4,18.4,0,1,1,18.4-18.4A18.4,18.4,0,0,1,25.286,76.687Z",
  transform: "translate(0 -33)",
  fill: "url(#linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3507",
  "data-name": "Path 3507",
  d: "M317.65,345.339l-5.311,5.311a2.128,2.128,0,0,1-3.01,0L298.6,339.917a5.883,5.883,0,1,1,8.32-8.32L317.65,342.33a2.128,2.128,0,0,1,0,3.01Z",
  transform: "translate(-253.691 -286.691)",
  fill: "url(#linear-gradient-5)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3508",
  "data-name": "Path 3508",
  d: "M337.329,342.335,326.6,331.6a5.885,5.885,0,0,0-6.694-1.15,5.873,5.873,0,0,1,1.626,1.15l10.734,10.734a2.128,2.128,0,0,1,0,3.01l-4.282,4.282,1.029,1.029a2.128,2.128,0,0,0,3.01,0l5.311-5.311a2.128,2.128,0,0,0,0-3.01Z",
  transform: "translate(-273.37 -286.696)",
  fill: "url(#linear-gradient-6)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3509",
  "data-name": "Path 3509",
  d: "M262.431,167.478c-.207-.7-.752-.778-1.322-.778-.6,0-1.115.078-1.322.778l-.24.806a18.482,18.482,0,0,1-.432,10.038.736.736,0,0,0,.284-.343l1.711-4.512,1.711,4.512c.128.362.64.6,1.249.675a18.47,18.47,0,0,0,.925-8.182l-.9,2.58Z",
  transform: "translate(-216.089 -147.253)",
  fill: "#ff3067",
  opacity: 0.3
}));

function SvgWebCrawlerSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.52,
    height: 64.58,
    className: "webcrawlersearchicon-svg",
    viewBox: "0 0 79.517 64.582",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCrawlerSearchIcon);
export default __webpack_public_path__ + "static/media/webCrawlerSearchIcon.539da535.svg";
export { ForwardRef as ReactComponent };